import { jsx } from '@emotion/core'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { calendarArrow_16 } from '@trustpilot/icons';
import { IconButton } from '../button';
export var NavBar = function NavBar(_a) {
  var className = _a.className,
      onNextClick = _a.onNextClick,
      onPreviousClick = _a.onPreviousClick;
  return jsx("div", {
    className: className
  }, jsx(IconButton, {
    className: "calendar-arrow previous",
    icon: calendarArrow_16,
    onClick: function onClick() {
      return onPreviousClick();
    }
  }), jsx(IconButton, {
    className: "calendar-arrow next",
    icon: calendarArrow_16,
    onClick: function onClick() {
      return onNextClick();
    }
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/navbar.js
// module id = 1032
// module chunks = 0